import { SERVICES } from "../constants/services.constant";

// IDs submitted to chat_threads must be company catalog IDs, never legacy
// global chat_category/chat_status IDs (develop's September migration).
export const chatCatalogRequest = (
  recordType: "category" | "status",
  companyId: string | number | null | undefined,
) => ({
  method: "get" as const,
  url: SERVICES.CATEGORY_STATUS_COMPANIES,
  params: {
    company_id: companyId,
    screen: "chat",
    record_type: recordType,
    is_hidden: false,
    per_page: 100,
  },
});
